import React from "react";

import "./styles/proofStrip.css";

// Credibility strip for the hero. Order is intentional: leadership scope,
// mentorship, domain depth, then range. Raw user counts and repo counts are
// deliberately out; every item here is a distinct, defensible signal.
const STATS = [
	{ number: "30+", label: "engineers led" },
	{ number: "25+", label: "engineers mentored" },
	{ number: "10+", label: "years in regulated finance" },
	{ number: "5", label: "industries shipped in" },
];

const ProofStrip = () => (
	<div className="proof-strip">
		{STATS.map((s) => (
			<div className="proof-item" key={s.label}>
				<div className="proof-num">{s.number}</div>
				<div className="proof-label">{s.label}</div>
			</div>
		))}
	</div>
);

export default ProofStrip;
